import { Card, CardContent } from "@/components/ui/card";
import {
  BanknoteIcon,
  ClockIcon,
  ShoppingBagIcon,
} from "lucide-react";

type OrdersSummaryCardsProps = {
  totalOrdersToday: number;
  pendingConfirmation: number;
  todayRevenue: number;
  isLoading?: boolean;
};

export function OrdersSummaryCards({
  totalOrdersToday,
  pendingConfirmation,
  todayRevenue,
  isLoading,
}: OrdersSummaryCardsProps) {
  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="rounded-xl border bg-card">
            <CardContent>
              <div className="h-10 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-6 w-16 animate-pulse rounded bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-3">
      <Card className="rounded-xl border border-blue-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-500/10">
            <ShoppingBagIcon className="size-5 text-blue-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ອໍເດີທັງໝົດມື້ນີ້
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              {totalOrdersToday.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-amber-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-amber-500/10">
            <ClockIcon className="size-5 text-amber-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ລໍຖ້າຢືນຢັນ
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              {pendingConfirmation.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-emerald-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-emerald-500/10">
            <BanknoteIcon className="size-5 text-emerald-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">
              ລາຍຮັບມື້ນີ້ (LAK)
            </p>
            <p className="font-semibold text-2xl tabular-nums">
              {todayRevenue.toLocaleString("lo-LA", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
